import { TEAM_USER_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case TEAM_USER_LIST.LOAD:
      return {
        ...state,
        loading: true
      };
    case TEAM_USER_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case TEAM_USER_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
